<button mat-icon-button
        class="notifications-bell"
        (click)="openDrawer()"
        aria-label="Notifications">
    <mat-icon class="text-white" fontSet="material-icons-outlined">notifications</mat-icon>
    <span *ngIf="unreadCount > 0" class="notification-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
</button>

<app-notification-list-drawer #notificationListDrawer></app-notification-list-drawer>
